import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { apiService } from '../../../../../service/api.service'
import { StorageService } from 'src/app/service/storage.service';

@Component({
  selector: 'app-modal-crear-consulta',
  templateUrl: './modal-crear-consulta.component.html',
  styleUrls: ['./modal-crear-consulta.component.css']
})
export class ModalCrearConsultaComponent implements OnInit {

  public formConsulta: FormGroup;
  agregarConsulta = false;
  constructor(
    public dialogRef: MatDialogRef<ModalCrearConsultaComponent>,
    private api: apiService,
    public storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.formulario();
  }

  formulario(){
    this.formConsulta = new FormGroup({
      titulo: new FormControl('', [Validators.required]),
      pregunta: new FormControl('', [Validators.required])    
    });
  }

  hasError (controlName: string, errorName: string){
    return this.formConsulta.controls[controlName].hasError(errorName);
  }

  enviarConsulta(formConsultaValue){
      if (this.formConsulta.valid) {
        this.agregarConsulta = true;
        formConsultaValue.idUsuario = this.storageService.getCurrentUser().idUsuario
        this.api.API_POST_crearForo(formConsultaValue).subscribe((response) => {
          this.agregarConsulta = false;
          this.dialogRef.close();
        },
        (err) => {
          console.log(err)
        })
      }
  }

  guardarConsulta(){
    
  }
}
